"use strict";

define(function (require, exports, module) {

    /**
     * @fileoverview callbacks
     * @author 子虔
     * @date    2014-08-31 12:09:10
     */
    module.exports = function (options) {
        options = $.extend({}, options);

        var memory,
            // Last fire value (for non-forgettable lists)
        _fired,
            // Flag to know if list was already fired
        firing,
            // Flag to know if list is currently firing
        firingStart,
            // First callback to fire (used internally by add and fireWith)
        firingLength,
            // End of the loop when firing
        firingIndex,
            // Index of currently firing callback (modified by remove if needed)
        list = [],
            // Actual callback list
        stack = !options.once && [],
            // Stack of fire calls for repeatable lists
        fire = function fire(data) {
            memory = options.memory && data;
            _fired = true;
            firingIndex = firingStart || 0;
            firingStart = 0;
            firingLength = list.length;
            firing = true;
            for (; list && firingIndex < firingLength; ++firingIndex) {
                if (list[firingIndex].apply(data[0], data[1]) === false && options.stopOnFalse) {
                    memory = false;
                    break;
                }
            }
            firing = false;
            if (list) {
                if (stack) stack.length && fire(stack.shift());else if (memory) list.length = 0;else Callbacks.disable();
            }
        },
            Callbacks = {
            list: list,
            add: function add() {
                if (list) {
                    var start = list.length,
                        add = function add(args) {
                        args = Array.prototype.slice.call(args);
                        args.forEach(function (arg, _) {
                            if (typeof arg === "function") {
                                if (!options.unique || !Callbacks.has(arg)) list.push(arg);
                            } else if (arg && arg.length && typeof arg !== 'string') add(arg);
                        });
                    };
                    add(arguments);
                    if (firing) firingLength = list.length;else if (memory) {
                        firingStart = start;
                        fire(memory);
                    }
                }
                return this;
            },
            remove: function remove() {
                var args = Array.prototype.slice.call(arguments);
                if (list) {
                    args.forEach(function (arg, _) {
                        var index;
                        while ((index = list.indexOf(arg, index)) > -1) {
                            list.splice(index, 1);
                            // Handle firing indexes
                            if (firing) {
                                if (index <= firingLength) --firingLength;
                                if (index <= firingIndex) --firingIndex;
                            }
                        }
                    });
                }
                return this;
            },
            has: function has(fn) {
                return !!(list && (fn ? list.indexOf(fn) > -1 : list.length));
            },
            empty: function empty() {
                firingLength = list.length = 0;
                return this;
            },
            disable: function disable() {
                list = stack = memory = undefined;
                return this;
            },
            disabled: function disabled() {
                return !list;
            },
            lock: function lock() {
                stack = undefined;
                if (!memory) Callbacks.disable();
                return this;
            },
            locked: function locked() {
                return !stack;
            },
            fireWith: function fireWith(context, args) {
                if (list && (!_fired || stack)) {
                    args = args || [];
                    args = [context, args.slice ? args.slice() : args];
                    if (firing) stack.push(args);else fire(args);
                }
                return this;
            },
            fire: function fire() {
                return Callbacks.fireWith(this, arguments);
            },
            fired: function fired() {
                return !!_fired;
            }
        };

        return Callbacks;
    };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/c-base/dist/callbacks/index.js
// module id = 41
// module chunks = 0